import { CyberSourceGenerateKeyResponse } from "../types/CyberSource";
import CyberSourceClient from "./CyberSourceClient";
import RequestixClient from "./RequestixClient";

export const getCreditCardKey = (): Promise<CyberSourceGenerateKeyResponse> =>
  RequestixClient.get(`/cybersource/generatekey`).then((response) => response.data.entity);

export const createCreditCardToken = (flex) =>
  CyberSourceClient.post(`/flex/v1/tokens`, flex).then((response) => response.data);

// Microform v2
export const getCaptureContext = (): Promise<string> =>
  RequestixClient.get(`/cybersource/capture-context`).then((response) => response.data.entity);

export type ExchangeTokenRequest = {
  transientToken: string;
  ccLast4?: string;
  ccType?: string;
  ccExp?: string;
  firstName?: string;
  lastName?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
  countryCode?: string;
  email?: string;
  phone?: string;
};

export const exchangeTransientToken = (payload: ExchangeTokenRequest) =>
  RequestixClient.post(`/cybersource/microform/tokenize`, payload).then((response) => response.data.entity);
